export const getReducerType = (version, componentName, componentAttribute) => {
  return `${version}_${componentName}_${componentAttribute}`;
};

export const convertComponentVersionToReducerType = (componentVersion) => {
  const attributes = componentVersion?.split("#");
  return attributes?.join("_");
};
